import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'view-child-demographic',
    templateUrl: './view-child-demographic.component.html',
    styleUrl: './view-child-demographic.component.scss'
})
export class ViewChildDemographicComponent implements OnInit {
    @Input() studentId!: number;
    @Input() studentHelperNumber: number = 1;

    constructor() {}

    ngOnInit(): void {
        this.init();
    }

    init() {}
}
